module.exports = __webpack_public_path__ + "img/楚雄市人民医院.eb180b73.png";